export default {
  name: 'eu',
  el: {
    breadcrumb: {
      label: 'Breadcrumb', // to be translated
    },
    colorpicker: {
      confirm: 'Ados',
      clear: 'Garbitu',
      defaultLabel: 'color picker', // to be translated
      description:
        'current color is {color}. press enter to select a new color.', // to be translated
      alphaLabel: 'pick alpha value', // to be translated
      alphaDescription: 'alpha {alpha}, current color is {color}', // to be translated
      hueLabel: 'pick hue value', // to be translated
      hueDescription: 'hue {hue}, current color is {color}', // to be translated
      svLabel: 'pick saturation and brightness value', // to be translated
      svDescription:
        'saturation {saturation}, brightness {brightness}, current color is {color}', // to be translated
      predefineDescription: 'select {value} as the color', // to be translated
    },
    datepicker: {
      now: 'Orain',
      today: 'Gaur',
      cancel: 'Utzi',
      clear: 'Garbitu',
      confirm: 'Ados',
      dateTablePrompt:
        'Use the arrow keys and enter to select the day of the month', // to be translated
      monthTablePrompt: 'Use the arrow keys and enter to select the month', // to be translated
      yearTablePrompt: 'Use the arrow keys and enter to select the year', // to be translated
      selectedDate: 'Selected date', // to be translated
      selectDate: 'Hautatu data',
      selectTime: 'Hautatu ordua',
      startDate: 'Hasierako data',
      startTime: 'Hasierako ordua',
      endDate: 'Amaierako data',
      endTime: 'Amaierako ordua',
      prevYear: 'Aurreko urtea',
      nextYear: 'Hurrengo urtea',
      prevMonth: 'Aurreko hilabetea',
      nextMonth: 'Hurrengo hilabetea',
      year: '',
      month1: 'Urtarrila',
      month2: 'Otsaila',
      month3: 'Martxoa',
      month4: 'Apirila',
      month5: 'Maiatza',
      month6: 'Ekaina',
      month7: 'Uztaila',
      month8: 'Abuztua',
      month9: 'Iraila',
      month10: 'Urria',
      month11: 'Azaroa',
      month12: 'Abendua',
      weeks: {
        sun: 'ig.',
        mon: 'al.',
        tue: 'ar.',
        wed: 'az.',
        thu: 'og.',
        fri: 'ol.',
        sat: 'lr.',
      },
      weeksFull: {
        sun: 'Sunday', // to be translated
        mon: 'Monday', // to be translated
        tue: 'Tuesday', // to be translated
        wed: 'Wednesday', // to be translated
        thu: 'Thursday', // to be translated
        fri: 'Friday', // to be translated
        sat: 'Saturday', // to be translated
      },
      months: {
        jan: 'urt',
        feb: 'ots',
        mar: 'mar',
        apr: 'api',
        may: 'mai',
        jun: 'eka',
        jul: 'uzt',
        aug: 'abu',
        sep: 'ira',
        oct: 'urr',
        nov: 'aza',
        dec: 'abe',
      },
    },
    inputNumber: {
      decrease: 'decrease number', // to be translated
      increase: 'increase number', // to be translated
    },
    select: {
      loading: 'Kargatzen',
      noMatch: 'Bat datorren daturik ez',
      noData: 'Daturik ez',
      placeholder: 'Hautatu',
    },
    mention: {
      loading: 'Kargatzen',
    },
    dropdown: {
      toggleDropdown: 'Toggle Dropdown', // to be translated
    },
    cascader: {
      noMatch: 'Bat datorren daturik ez',
      loading: 'Kargatzen',
      placeholder: 'Hautatu',
      noData: 'Daturik ez',
    },
    pagination: {
      goto: 'Joan',
      pagesize: '/orria',
      total: 'Guztira {total}',
      pageClassifier: '',
      page: 'Page', // to be translated
      prev: 'Go to previous page', // to be translated
      next: 'Go to next page', // to be translated
      currentPage: 'page {pager}', // to be translated
      prevPages: 'Previous {pager} pages', // to be translated
      nextPages: 'Next {pager} pages', // to be translated
      deprecationWarning:
        'Deprecated usages detected, please refer to the el-pagination documentation for more details', // to be translated
    },
    dialog: {
      close: 'Close this dialog', // to be translated
    },
    drawer: {
      close: 'Close this dialog', // to be translated
    },
    messagebox: {
      title: 'Mezua',
      confirm: 'Ados',
      cancel: 'Utzi',
      error: 'Sarrera baliogabea',
      close: 'Close this dialog', // to be translated
    },
    upload: {
      deleteTip: 'sakatu Ezabatu kentzeko',
      delete: 'Ezabatu',
      preview: 'Aurrebista',
      continue: 'Jarraitu',
    },
    slider: {
      defaultLabel: 'slider between {min} and {max}', // to be translated
      defaultRangeStartLabel: 'pick start value', // to be translated
      defaultRangeEndLabel: 'pick end value', // to be translated
    },
    table: {
      emptyText: 'Daturik ez',
      confirmFilter: 'Baieztatu',
      resetFilter: 'Berrezarri',
      clearFilter: 'Guztia',
      sumText: 'Batura',
      selectAllLabel: 'Select all rows', // to be translated
      selectRowLabel: 'Select this row', // to be translated
      expandRowLabel: 'Expand this row', // to be translated
      collapseRowLabel: 'Collapse this row', // to be translated
      sortLabel: 'Sort by {column}', // to be translated
      filterLabel: 'Filter by {column}', // to be translated
    },
    tag: {
      close: 'Close this tag', // to be translated
    },
    tour: {
      next: 'Hurrengoa',
      previous: 'Aurrekoa',
      finish: 'Bukatu',
      close: 'Close this dialog', // to be translated
    },
    tree: {
      emptyText: 'Daturik ez',
    },
    transfer: {
      noMatch: 'Bat datorren daturik ez',
      noData: 'Daturik ez',
      titles: ['Zerrenda 1', 'Zerrenda 2'],
      filterPlaceholder: 'Sartu gako-hitza',
      noCheckedFormat: '{total} elementu',
      hasCheckedFormat: '{checked}/{total} hautatuta',
    },
    image: {
      error: 'FAILED', // to be translated
    },
    pageHeader: {
      title: 'Back', // to be translated
    },
    popconfirm: {
      confirmButtonText: 'Yes', // to be translated
      cancelButtonText: 'No', // to be translated
    },
    carousel: {
      leftArrow: 'Carousel arrow left', // to be translated
      rightArrow: 'Carousel arrow right', // to be translated
      indicator: 'Carousel switch to index {index}', // to be translated
    },
    inputOTP: {
      groupLabel: 'OTP Input', // to be translated
      defaultLabel: 'Please enter OTP character {index}', // to be translated
    },
  },
}
